import { forwardRef } from 'react';
import cx from 'classnames';
import { postfixTestId } from '../../../util/testId';
import { Text } from '../../Text';
import cn from './SliderGripLabel.css.json';
import './SliderGripLabel.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SliderGripLabel = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    [props.orientation === 'vertical' ? 'end' : 'start']: styleSpacerStart,
    [props.orientation === 'vertical' ? 'start' : 'end']: styleSpacerEnd
    // prettier
  } = flexCenter(props.position);
  const labelClassName = cx(cn.label, cn.inputPadding[props.orientation], props.className, props.disabled && cn.disabled, (props.hideLabel || props.isRange) && cn.labelHide);
  return props.hideLabel ? null : /*#__PURE__*/_jsxs("div", {
    "data-testid": postfixTestId(props.testId, 'container'),
    className: cx(cn.container[props.orientation], props.containerClassName),
    style: props.containerStyle,
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      className: cn.spacerStart,
      style: styleSpacerStart
    }), Array.isArray(props.label) ? props.label.map((label, index) => /*#__PURE__*/_jsx("div", {
      "data-testid": postfixTestId(props.testId, index === 0 ? 'max' : 'min'),
      className: cn.spacerCenter,
      children: /*#__PURE__*/_jsx(Text, {
        className: labelClassName,
        style: props.style,
        disabled: props.disabled,
        onClick: () => props.onPress?.(),
        wrapText: false,
        children: label
      })
    }, index)) : /*#__PURE__*/_jsxs("div", {
      "data-testid": props.testId,
      className: cn.spacerCenter,
      children: [/*#__PURE__*/_jsx(Text, {
        className: labelClassName,
        style: props.style,
        disabled: props.disabled,
        onClick: event => {
          // ignore click events that bubble from props.children
          if (event.currentTarget === event.target) {
            props.onPress?.();
          }
        },
        wrapText: false,
        children: props.label
      }), props.children]
    }), /*#__PURE__*/_jsx("div", {
      className: cn.spacerEnd,
      style: styleSpacerEnd
    })]
  });
});
function flexCenter(start) {
  const end = 1 - start;

  /* Setting the left shrink factor to right and the right shrink factor to left
   * will result in the negative space (space for props.children) being distributed
   * evenly to left and right.
   *
   * flex-shrink below one doesn't really shrink anymore (it grows, sort-of). */
  return {
    start: {
      flexBasis: `${start * 100}%`,
      flexShrink: Math.max(end * 1000, 1)
    },
    end: {
      flexBasis: `${end * 100}%`,
      flexShrink: Math.max(start * 1000, 1)
    }
  };
}
//# sourceMappingURL=SliderGripLabel.js.map